import React, { useEffect } from 'react';
import $ from 'jquery';
import * as R from 'ramda';
import countriesList from 'iso-3166-1-alpha-2';
import {RegexFields} from '../../../../../../constants/utils/regexFields';
import { PostalCityInput } from "../../../../../../_common/postalCityInput";

export const RetraiteCustomForm = ({payload, setPayload, index}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    return (
			<div className="row gx-2 mt-n2">
				<div className="col-12 col-md-5">
					<div className="form-group">
						<label className="h6 font-weight-bolder my-auto" htmlFor={"companyName" + index}>
							Nom du régime
						</label>
						<input type="text" className="form-control" id={"companyName" + index} placeholder="Nom du régime" value={payload.name} onChange={(e) => setPayload({ ...payload, name: e.target.value })} required />
					</div>
				</div>
				<div className="col-12 col-md-7">
					<div className="form-group">
						<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
							Agence
						</label>
						<input required type="text" className="form-control" id={"Adresseentreprise" + index} placeholder="Adresse de l'agence" value={payload.address.streetAddress} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress: e.target.value } })} required />
						<div className="invalid-feedback">
							<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
							<span className="align-middle text-dark o-70">Ce champ est requis</span>
						</div>
					</div>
					<div className="form-group">
						<div className="flex-row gx-2 align-items-center mb-1">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
								Adresse ligne 1
							</label>
							<p
								className="form-text small text-gray my-auto ml-auto"
								data-toggle="tooltip"
								data-placement="top"
								data-html="true"
								data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
								title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
								<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
							</p>
						</div>
						<input required type="text" className="form-control" id={"Adresseentreprise" + index} placeholder="Adresse de l'agence" value={payload.address.streetAddress2} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress2: e.target.value } })} required />
						<div className="invalid-feedback">
							<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
							<span className="align-middle text-dark o-70">Ce champ est requis</span>
						</div>
					</div>
					<div className="form-group">
						<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + index}>
							Adresse ligne 2
						</label>
						<input type="text" className="form-control rounded" id={"Adresseligne2" + index} value={payload.address.streetAddress3} placeholder="Adresse de l'agence ligne 2" onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress3: e.target.value } })} />
					</div>
					<div className="form-row">
						<PostalCityInput
							postalCode={payload.address.postalCode}
							city={payload.address.addressLocality}
							onChange={(updatedAddress) => setPayload({ ...payload, address: { ...payload.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } })}
							hasWrapper={false}
							country={payload.address.addressCountry}
							customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
						/>
						{/* <div className="form-group col-12 col-sm-6 col-lg">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise" + index} required>
								Code Postal
							</label>
							<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={payload.address.postalCode} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, postalCode: e.target.value } })} pattern={RegexFields.frenchZipCode} required />
							<div className="invalid-feedback">
								<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
								<span className="align-middle text-dark o-70">Ce champ est requis</span>
							</div>
						</div>
						<div className="form-group col-12 col-sm-6 col-lg">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise" + index} required>
								Ville
							</label>
							<input required type="text" className="form-control" id={"Villeentreprise" + index} placeholder="ex: Paris" value={payload.address.addressLocality} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressLocality: e.target.value } })} required />
							<div className="invalid-feedback">
								<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
								<span className="align-middle text-dark o-70">Ce champ est requis</span>
							</div>
						</div> */}
						<div className="form-group col-12 col-sm-6 col-lg">
							<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise" + index}>
								Pays
							</label>
							<select className="custom-select" id={"Paysentreprise" + index} defaultValue="FR" value={payload.address.addressCountry} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressCountry: e.target.value } })}>
								{Object.keys(countriesList.getData()).map((country, idx) => {
									return (
										<option key={idx} value={country}>
											{countries.getName(country, "fr", { select: "official" })}
										</option>
									);
								})}
							</select>
						</div>
					</div>
				</div>
			</div>
		);
}